import { InformationCircleIcon } from "@heroicons/react/solid";

import { minFee } from "koljobs-constants";

export const BusinessProfileRewardAlert = () => {
  return (
    <div className="rounded-md bg-blue-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon
            className="h-5 w-5 text-blue-400"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-blue-800">
            完善個人資料，將饋贈{minFee}點數
          </p>
        </div>
      </div>
    </div>
  );
};
